export enum EKwikUIStepperOrientation {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical"
}
export const VKwikUIStepperOrientation = [
  EKwikUIStepperOrientation.HORIZONTAL,
  EKwikUIStepperOrientation.VERTICAL
] as const;

export type TKwikUIStepperOrientation =
  (typeof VKwikUIStepperOrientation)[number];

export type TKwikUIStep = {
  label: string;
  state: TKwikUIStepState;
};

export enum EKwikUIStepState {
  NORMAL = "normal",
  PASS = "pass",
  ERROR = "error"
}

export const VKwikUIStepState = [
  EKwikUIStepState.NORMAL,
  EKwikUIStepState.PASS,
  EKwikUIStepState.ERROR
] as const;

export type TKwikUIStepState = (typeof VKwikUIStepState)[number];
